import React, { useEffect, useState } from "react";
import {
  Dropdown,
  Modal,
  ModalHeader,
  Nav,
  Offcanvas,
  Table,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCancel,
  faCross,
  faEllipsis,
  faFile,
  faTrash,
  faXmark,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";
import "./InvoiceOrder.css";
import "../../Utils/assets/css/styles.css";
import { useNavigate } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import {
  formatDate,
  formatToINR,
  TextWithLineBreaks,
} from "../../Utils/helpers/commonhelper";
import {
  DeleteRequest,
  GetRequest,
  PostRequest,
} from "../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { baseURL, imageURL } from "../../Utils/constants/constant";
import DeleteModal from "../DeleteModal";
// import { EmailModal } from "../detailPage/leads/EmailModal";
import { WhatsappModal } from "../../pages/WhatsappModal";
import { EmailModal } from "../detailPage/leads/EmailModal";
import { SalesOrder } from "../SalesOrder/SalesOrder";
import pugcrm_logo from "./.././../Utils/assets111/img/pugcrm_logo.png";

const RecurringInvoiceDetails = ({
  setShowSalesOrderDetails,
  show,
  handleClose,
  salesDetails,
  fetchSalesOrder,
  detailPageId,
}) => {
  const navigate = useNavigate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // pdf view toggle
  const [pdfView, setPdfView] = useState(false);

  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });

  const customer_id = customer?.customer_details?.customer_id || 1;
  const token = customer?.token?.authorization || "";
  const rf = customer?.token?.authentication || "";
  const extras = { customer, setCustomer, rf, navigate };
  const headers = {
    Authorization: token,
    Authentication: rf,
  };
  const loginUserId = customer?.customer_details?.id;
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPaymentList, setShowPaymentList] = useState(false);

  // WhatsApp modal state
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [cloneData, setCloneData] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  //delete modal loading state
  const [loading, setLoading] = useState(false)

  const fetchDetailsOfSpecificInvoice = async () => {
    if (!detailPageId) return;
    try {
      const res = await GetRequest(
        `/invoice/fetchDetailsOfSpecificRecurringInvoice/${detailPageId}/${customer_id}`,
        { headers },
        extras
      );

      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message);
      }

      if (res.status === "success") {
        setCloneData(res.data[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (detailPageId) {
      fetchDetailsOfSpecificInvoice();
    }
  }, [detailPageId]);

  //create payment page
  const handleAddClick = () => {
    const dataToSend = {
      key1: cloneData.id,
      key2: cloneData.contact_id,
      key3: cloneData.contact_full_name,
    };
    navigate("/createpayment", { state: dataToSend });
  };

  const fetchPaymentList = async () => {
    try {
      const res = await GetRequest(
        `invoice/fetchPayments/${customer_id}/${cloneData?.id}`,
        { headers },
        extras
      );

      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message || "something went wrong");
      }
      if (res.status === "success") {
        toast.success(res.message);

        setPaymentList(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showPaymentList) {
      fetchPaymentList();
    }
  }, [showPaymentList]);

  const parsedBillingAddress = cloneData?.billing_address
    ? JSON.parse(cloneData.billing_address)
    : {};

  const parsedShippingAddress = cloneData?.shipping_address
    ? JSON.parse(cloneData?.shipping_address)
    : "";

  const parsedCompanyBillingAddress = cloneData?.company_billing_address
    ? JSON.parse(cloneData?.company_billing_address)
    : "";


  const itemsDetailsData = cloneData?.items ? JSON.parse(cloneData.items) : [];

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };

  const sendSalesOrder = async () => {
    const payload = {
      customer_id: customer_id,
      order_id: salesDetails?.id,
    };
    const res = await PostRequest(
      `sales/sendSalesOrder`,
      payload,
      false,
      { headers },
      { extras }
    );
  };
  const handleConfirmDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `sales/deleteSalesOrder/${salesDetails.id}/${customer?.customer_details?.id}`,
        { headers },
        { extras }
      );
      if (res?.status === "success") {
        toast.success(res.message);
        await fetchSalesOrder();
      } else if (res.status === "fail") {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("delete error:", error);
    } finally {
      setLoading(false)
      setShowSalesOrderDetails(false);
      setShowDeleteModal(false);
    }
  };
  if (showDeleteModal) {
    return (
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        isLoading={loading}
        message={"Are you sure you want to delete this sales order"}
      />
    );
  }
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        backdrop="static"
        className="offcanvas offcanvas-end w-75"
      >
        <div
          className="offcanvas-header align-items-center border-bottom justify-content-between py-3 px-4"
          id="saleOrderDetails"
          aria-labelledby="staticBackdropLabel"
        >
          {/* <h5 className="offcanvas-title" id="staticBackdropLabel">
            {cloneData.invoice_number || "-"}
          </h5> */}
          <h3
            className=" mb-0"
            style={{
              whiteSpace: "nowrap",
              fontWeight: 300,
              fontSize: "22px",
            }}
          >
            Recurring Invoice Details-
            <span className="ms-1" style={{ color: "#0099ff" }}>
              #{cloneData.invoice_number || "-"}
            </span>
          </h3>
          <div className="d-flex align-items-center">
            <label
              htmlFor="pic"
              className="divslabel me-2 btn btn-primary btn-sm mb-0"
            >
              <span>
                <i className="bi bi-file-earmark-arrow-up"></i>
                Upload File
              </span>
              <input type="file" id="pic" className="uploadsInput" />
            </label>{" "}
            |
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
        </div>

        <Offcanvas.Body style={{ paddingLeft: 31, paddingRight: 31 }}>
          {/* 🔽 List */}
          <div className="row d-flex align-items-center">
            <div className="col-md-9">
              {" "}
              <ul className="list-unlisted gap-1 justify-content-between">
                <div className="d-flex align-items-center gap-1">
                  {" "}
                  {/* <Dropdown as="div" className="dropdownsWithoutToggle">
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                      <li className="listed">
                        <i className="bi bi-send"></i>
                        Send
                      </li>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                      style={{ right: "3.4rem" }}
                    >
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                        onClick={() => {
                          setShowEmailModal(true);
                        }}
                      >
                        {" "}
                        Email
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                        onClick={() => {
                          setShowWhatsappModal(true);
                        }}
                      >
                        {" "}
                        WhatsApp
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                  {/* <li className="listed">
                    <i className="bi bi-share"></i> Share
                  </li> */}
                  {/* <Dropdown as="div" className="dropdownsWithoutToggle">
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                      <li className="listed">
                        <i className="bi bi-printer"></i>
                        PDF/Print
                      </li>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                      style={{ right: "3.4rem" }}
                    >
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Print{" "}
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={
                          baseURL +
                          `invoice/downloadInvoice/${customer_id}/${cloneData?.id}`
                        }
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Download
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                  {/* <Dropdown as="div" className="dropdownsWithoutToggle">
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                      <li className="listed">
                        <i className="bi bi-stopwatch"></i>
                        Reminder
                      </li>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                      style={{ right: "3.4rem" }}
                    >
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Send Email
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Stop Reminder
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={
                          baseURL +
                          `/sales/downloadSalesOrder/${customer_id}/${salesDetails?.id}`
                        }
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Payment Followup Date
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown as="div" className="dropdownsWithoutToggle">
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                      <li className="listed">
                        <i class="bx bx-rupee" />
                        Payment
                      </li>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                      style={{ right: "3.4rem" }}
                    >
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                        onClick={() => {
                          handleAddClick();
                        }}
                      >
                        {" "}
                        Record Payment
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={"#"}
                        className="d-flex align-items-center"
                        onClick={() => {
                          setShowPaymentList(true);
                        }}
                      >
                        {" "}
                        Payment List
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={"#"}
                        className="d-flex align-items-center"
                      >
                        {" "}
                        WriteOff
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                  {/* <li className="listed" onClick={sendSalesOrder}>
                  Create Credit Note
                </li>
                <li className="listed" onClick={sendSalesOrder}>
                  Create Debit Note
                </li> */}
                  {/* <Dropdown as="div" className="dropdownsWithoutToggle">
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                      <li className="listed px-2">
                        <div className="btn-group dropdownsWithoutToggle">
                          <button
                            type="button"
                            className=" dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ border: "none", background: "none" }}
                          >
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                          </button>
                        </div>
                      </li>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                      style={{ right: "3.4rem" }}
                    >
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                      >
                        {" "}
                        View Payments
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={sendSalesOrder}
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Create Credit Note
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={sendSalesOrder}
                        className="d-flex align-items-center"
                      >
                        {" "}
                        Create Debit Note
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                        onClick={() => {
                          navigate(`/cloneInvoice/${cloneData?.id}`);
                        }}
                      >
                        {" "}
                        Clone
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        className="d-flex align-items-center"
                        onClick={() => setShowDeleteModal(true)}
                      >
                        {" "}
                        Delete{" "}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </div>
              </ul>
            </div>

            <div className="col-md-3">
              {" "}
              <div className="clearfix pb-0">
                <div className="float-end so-details-preview d-flex gap-2 align-items-center">
                  <i className="preview-label" id="a45f71bf0">
                    Show PDF View
                  </i>
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="toggleShowHidePdf"
                      onChange={() => setPdfView(!pdfView)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showPaymentList && (
            <>
              <div
                className="table custom-scroll "
                style={{
                  height:
                    paymentList && paymentList.length > 10 ? "150px" : "auto",
                  maxHeight: "300px",
                  overflowX:
                    paymentList && paymentList.length > 10 ? "auto" : "hidden",
                  overflowY:
                    paymentList && paymentList.length > 10 ? "auto" : "hidden",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid #ccc",
                }}
              >
                {/* Header with Close button */}
                <div className="d-flex justify-content-between align-items-center px-2 py-2">
                  <div style={{ fontWeight: "bold" }}>Payment List</div>
                  <FontAwesomeIcon
                    onClick={() => setShowPaymentList(false)}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      color: "red",
                    }}
                    icon={faXmark}
                  />
                </div>

                {/* Table */}
                <Table
                  className="listStyleForContact"
                  bordered
                  hover
                  responsive
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Payment number</th>
                      <th>Reference number</th>
                      <th>Account Type</th>
                      <th>Payment Mode</th>
                      <th>Amount Received</th>
                      <th>Bank Charges</th>
                      <th>Payment Date</th>
                      <th>Payment received on</th>
                      <th>Amount deducted</th>
                      <th>Tax deducted</th>
                      <th>Tds Tax Account</th>
                      <th>Attachment</th>
                    </tr>
                  </thead>

                  <tbody style={{ textAlign: "start" }}>
                    {paymentList && paymentList.length > 0 ? (
                      paymentList.map((saleOrder, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{saleOrder.payment_number}</td>
                          <td
                            style={{ color: "#0099ff", cursor: "pointer" }}
                            onClick={() => setShowSalesOrderDetails(true)}
                          >
                            {saleOrder.reference_number}{" "}
                            <i className="fa-regular fa-envelope"></i>
                          </td>
                          <td>{saleOrder.account_name}</td>
                          <td>{saleOrder.payment_mode}</td>
                          <td>{saleOrder.amount_recevied}</td>
                          <td>{saleOrder.bank_charges}</td>
                          <td>{saleOrder.payment_date}</td>
                          <td>{saleOrder.payment_recieved_on}</td>
                          <td>{saleOrder.amount_deducted}</td>
                          <td>{saleOrder.tax_deducted}</td>
                          <td>{saleOrder.tds_tax_account || "-"}</td>
                          {/* <td>{saleOrder.attachment}</td> */}
                          <td>
                            {saleOrder.attachment ? (
                              <a
                                href={`${baseURL}${saleOrder.attachment}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "#007bff",
                                }}
                              >
                                <FontAwesomeIcon
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    cursor: "pointer",
                                    color: "grey",
                                  }}
                                  icon={faFile}
                                />
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="13"
                          style={{ textAlign: "center", color: "gray" }}
                        >
                          No Sales Order found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {/* 🔽 What's Next */}

          <div className="rounded-lg mt-4 mb-1 ms-0 me-0 p-3 border">
            <div className="d-flex align-items-center flex-wrap">
              <div className="d-flex align-items-center">
                <img
                  src="https://www.shutterstock.com/image-vector/ai-illustration-icon-design-pack-600nw-2586528719.jpg"
                  style={{ width: "30px" }}
                />
                <div className="font-xs text-semibold text-primary-black fs-13 ms-1">
                  WHAT'S NEXT?
                </div>
              </div>
              <div className="my-auto d-flex align-items-center ms-2">
                <p className="font-small text-primary-black me-3 fs-13 mb-0">
                  Convert the sales order into packages, shipments, or invoices.
                </p>
                <div
                  id="dd-d13515e0-ba42-45d5-9d01-e19375f7bc58"
                  className="dropdown ember-view"
                >
                  <button
                    htmlFor="d13515e0-ba42-45d5-9d01-e19375f7bc58"
                    aria-controls="d13515e0-ba42-45d5-9d01-e19375f7bc58"
                    aria-haspopup="true"
                    aria-expanded="false"
                    className="dropdown-toggle no-caret  text-center btn btn-sm over-flow me-3 btn-primary"
                    type="button"
                  >
                    <span className="ps-1">Convert</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* New Sales Order */}
          <div
            className="border-top-light border-bottom"
            id="normalViews"
            style={{ display: pdfView ? "none" : "block" }}
          >
            <div className="row w-100 ms-0 pt-4">
              <div
                // style={{ background: "#edffed" }}
                // className="row mb-3 pt-3 ms-0 w-100 border border-1"
                className="ms-0 w-100"
                style={{ backgroundColor: "rgb(237, 255, 237)" }}
              >
                <Row className="mt-4 px-1">
                  <Col md={6}>
                    <h3
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "rgb(49, 49, 49)",
                      }}
                    >
                      Sales Order
                    </h3>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex align-items-end justify-content-end">
                      <span className="font-small">
                        <span style={{ fontWeight: 200 }}>Sales Order </span>
                        <strong className="font-small">
                          #{cloneData?.sale_no || "-"}
                        </strong>
                      </span>
                    </div>
                  </Col>
                </Row>
                <hr />

                {/* Details Body */}
                <Row className="ms-0 w-100">
                  {/* Left Column: General Info */}
                  <Col md={6} className="ps-0 mb-4">
                    <h3
                      className="pt-0 mb-2 ps-2"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        marginBottom: 14,
                        color: "#0099ff",
                      }}
                    >
                      Customer Details
                    </h3>
                    <div style={{ borderRadius: 4 }} className="ps-2">
                      <Row>
                        <Col md={12}>
                          <Form.Group className="mb-0" controlId="formCustomer">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span
                                style={styles.cardLabel}
                                className="text-secondary"
                              >
                                Customer Name
                              </span>
                              <p
                                className="text-primary"
                                style={styles.cardLebelData}
                              >
                                <span className="pe-1 fw-semibold">:</span>
                                {cloneData?.contact_full_name || "-"}
                              </p>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formOrderDate"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Order Date
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {formatDate(cloneData?.invoice_date) || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row> */}

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formShipmentDate"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Shipment Date
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {formatDate(salesDetails?.shipment_date)} */}
                              {formatDate(cloneData?.shipment_date) || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formSalesperson"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Sales Person
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {salesDcloneDataetails?.owner_name || "-"} */}
                              {cloneData?.sales_person_name || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formPaymentTerms"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Payment Terms
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {salesDetails?.payment_term || "-"} */}
                              {cloneData?.payment_terms || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Status Row */}
                      {/* <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formStatus"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Delivery Method
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1">:</span>
                              Test(Static)
                            </p>
                          </Form.Group>
                        </Col>
                      </Row> */}
                    </div>
                  </Col>

                  {/* Right Column: Addresses */}
                  <Col
                    md={6}
                    className="mb-4 d-flex flex-column ms-0 align-items-end"
                    style={{ textAlign: "end", paddingRight: "0.3rem" }}
                  >
                    {/* Billing Address */}
                    <div style={{ borderRadius: 4 }}>
                      <h3
                        className="pt-0 mb-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          marginBottom: 14,
                          color: "#0099ff",
                        }}
                      >
                        Billing Address
                      </h3>
                      <div className="mt-0 mb-2 col-md-12">
                        <div className="w-100 mb-3">
                          {Object.keys(parsedBillingAddress || {}).length ===
                            0 ? (
                            <p className="fs-13 text-muted">
                              No Billing Address
                            </p>
                          ) : (
                            <>
                              {/* <div className="mb-0 fs-14 text-dark d-flex flex-column">
                                <span className="d-block fs-14 text-dark fw-bold">
                                  {cloneData?.contact_full_name &&
                                    cloneData?.contact_full_name}
                                </span>
                              </div> */}
                              <div
                                style={{ fontSize: "13px", fontWeight: 300 }}
                              >
                                <p
                                  style={{ fontSize: "13px", fontWeight: 300 }}
                                >
                                  {" "}
                                  {parsedBillingAddress?.address &&
                                    parsedBillingAddress?.address}
                                </p>
                                <p
                                  className="mb-3"
                                  style={{ fontSize: "13px", fontWeight: 300 }}
                                >
                                  <p className="mb-1 fs-13">
                                    {[
                                      parsedBillingAddress?.city,
                                      parsedBillingAddress?.state,
                                      parsedBillingAddress?.country,
                                      parsedBillingAddress?.zipcode,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </p>
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Shipping Address */}
                    <div className="">
                      <h3
                        className="pt-2 mb-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          marginBottom: 14,
                          color: "#0099ff",
                        }}
                      >
                        Shipping Address
                      </h3>

                      {parsedShippingAddress ? (
                        <>
                          {/* <div className="mb-0 fs-14 text-dark">
                            <span className="d-block fs-14 text-dark fw-bold">
                              {cloneData?.contact_full_name &&
                                cloneData?.contact_full_name}
                            </span>
                          </div> */}
                          <div style={{ fontSize: "13px", fontWeight: 300 }}>
                            <p style={{ fontSize: "13px", fontWeight: 300 }}>
                              {" "}
                              {parsedShippingAddress?.address &&
                                parsedShippingAddress?.address}{" "}
                            </p>{" "}
                            <p
                              className="mb-3"
                              style={{ fontSize: "13px", fontWeight: 300 }}
                            >
                              {parsedShippingAddress?.city &&
                                `${parsedBillingAddress?.city}`}
                              {parsedShippingAddress?.state &&
                                `,${parsedShippingAddress?.state}`}
                              {parsedShippingAddress?.country &&
                                `, ${parsedShippingAddress?.country}`}
                              {parsedShippingAddress?.zipcode &&
                                `, ${parsedShippingAddress?.zipcode}`}
                            </p>
                          </div>
                        </>
                      ) : (
                        <p className="fs-13 text-muted">Same as Billing</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              {/* 🔽 Status Section */}
              {/* <div className="row mt-3 mb-3 w-100 pe-0 ms-0 me-0 pe-0">
                <h3
                  className="ps-0 mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Status
                </h3>

             
                <div className="col-md-3 mb-2 ps-0 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Status
                    </p>
                    <p
                      id="fbaec39e-f512-4cf8-9fb8-e68fc86fad51"
                      className="text-uppercase fw-semibold"
                    >
                      <a
                        href="#"
                        style={{
                          fontSize: "14px",
                          color: "rgb(91 142 85)",
                          letterSpacing: "0.4px",
                          padding: "0px",
                        }}
                      >
                        {cloneData?.status || "-"}
                      </a>
                    </p>
                  </div>
                </div>

          
                <div className="col-md-3 mb-2 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Invoice
                    </p>
                    <p className="fw-semibold text-dark">Not Invoiced</p>
                  </div>
                </div>

                <div className="col-md-3 mb-2 pe-0">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Payment
                    </p>
                    <p className="fw-semibold text-dark">Unpaid(static)</p>
                  </div>
                </div>

            
                <div className="col-md-3 mb-2">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Shipment
                    </p>
                    <p className="fw-semibold text-dark">Pending(static)</p>
                  </div>
                </div>
              </div> */}
            </div>

            <Row
              id="itemsDetailsSection"
              style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
              className="mt-4"
            >
              <h3
                className="ps-0 mb-3"
                style={{
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "19px",
                  color: "#0099ff",
                }}
              >
                Items Details
              </h3>

              <Col md={12} className="pe-0 ps-0">
                <div className="table-responsive quatationsTables2 mb-3 ">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }} className="text-start">
                          Items &amp; Description
                        </th>
                        <th style={{ width: "10%" }} className="text-end">
                          Quantity
                        </th>
                        <th style={{ width: "11%" }} className="text-end">
                          GST(
                          <i className="bi bi-percent"></i>)
                        </th>
                        <th style={{ width: "11%" }} className="text-end">
                          Rate(<i className="ti ti-currency-rupee"></i>)
                        </th>
                        <th style={{ width: "16%" }} className="text-end">
                          Discount(
                          <i className="bi bi-percent"></i>/
                          <i className="ti ti-currency-rupee"></i>)
                        </th>
                        <th
                          style={{ width: "11%" }}
                          className="text-center pe-2"
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemsDetailsData[0]?.itemDetails?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-start">
                            <div>
                              <p
                                className="w-100 mb-0 d-flex fs-13 align-items-center text-dark justify-content-between"
                                style={{
                                  fontWeight: 500,
                                  textTransform: "capitalize",
                                  width: "auto",
                                }}
                              >
                                {" "}
                                {item.name ?? "-"}
                              </p>
                              <p className="mb-0" style={{ cursor: "pointer" }}>
                                {item.itemDescription || "-"}{" "}
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-2 pt-0 "
                            >
                              {item?.quantity ?? "-"}{" "}
                            </span>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-3 pt-0"
                            >
                              {item?.gst ?? "-"}
                              <i className="bi bi-percent"></i>
                            </span>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-2 pt-0"
                            >
                              {formatToINR(item?.Rate ?? "-")}
                            </span>
                          </td>

                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-3 pt-0"
                            >
                              {item.discount}
                              {item.discountType === "Percentage" ? (
                                <i className="bi bi-percent"></i>
                              ) : (
                                <i className="ti ti-currency-rupee"></i>
                              )}
                            </span>
                          </td>

                          <td className="text-end">
                            <div className="d-flex gap-2 align-items-center justify-content-center pe-3">
                              <div
                                className="fs-14 text-end"
                                style={{ fontWeight: 500, fontSize: 14 }}
                              >
                                {formatToINR(item.discountedAmount ?? "-")}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}

                      <tr>
                        <th
                          className="text-start bg-transparent border-0 vertical-top w-100"
                          style={{ verticalAlign: "top" }}
                        >
                          <div className="mt-3 mb-3">
                            <p
                              className="ps-1 mb-2 fs-14"
                              style={{ fontWeight: 400 }}
                            >
                              Customer Note
                            </p>
                            <p className=" ps-1 text-wrap fs-13 fw-normal">
                              {cloneData?.customer_note ?? "-"}
                            </p>
                          </div>
                        </th>
                        <th
                          colSpan={5}
                          className="text-start bg-transparent border-0 "
                        >
                          <div
                            className=" w-100 h-100 mt-3 mb-3 "
                            style={{
                              borderRadius: 5,
                              background: "#f9f9fb",
                              padding: "1rem",
                            }}
                          >
                            <div className="row sub-total mb-2 ">
                              <div className="total-label col-md-6 d-flex align-items-center fs-14">
                                Sub Total
                              </div>
                              <div className="total-amount text-end fw-500 fs-14 col-md-6 d-flex align-items-center gap-1 justify-content-end">
                                {/* {formatToINR(items[0]?.subTotal)} */}
                                {formatToINR(
                                  itemsDetailsData[0]?.["sub-total"] || 0
                                )}
                              </div>
                            </div>

                            <div className="row sub-total mb-1">
                              <div className="total-label col-md-4 d-flex  align-items-center fw-400 text-secondary fs-13">
                                Special Discount
                                <span className="ps-1 fs-13">
                                  ({itemsDetailsData[0]?.special_discount}
                                  <span className="pe-1">
                                    <i>
                                      {
                                        itemsDetailsData[0]
                                          ?.special_DiscountType
                                      }
                                    </i>
                                  </span>
                                  )
                                </span>
                              </div>

                              <div className="total-amount text-end fw-400 text-secondary fs-13 col-md-8 d-flex align-items-center justify-content-end">
                                -
                                {formatToINR(
                                  itemsDetailsData[0]
                                    ?.special_Discount_Amount || 0
                                )}
                              </div>
                            </div>
                            <div className="row sub-total mb-1">
                              <div className="total-label col-md-4 d-flex align-items-center fw-400 text-secondary fs-13">
                                Shipping Charge
                              </div>
                              <div className="total-amount text-end col-md-5 justify-content-center d-flex gap-1">
                                <span></span>
                              </div>

                              <div className="total-amount text-end fw-400 text-secondary fs-13 col-md-3 d-flex align-items-center gap-1 justify-content-end">
                                {formatToINR(
                                  itemsDetailsData[0]?.shipping_Charge || 0
                                )}
                              </div>
                            </div>

                            <div>
                              {itemsDetailsData[0]?.gstBreakdown?.map((gst) => (
                                <div
                                  className="row sub-total mb-1"
                                  key={gst?.gst}
                                >
                                  <div className="total-label col-md-4 d-flex align-items-center fw-400 text-secondary fs-13">
                                    GST
                                    <span className="ps-1 fs-13">
                                      ({gst?.gst}%)
                                    </span>
                                  </div>
                                  <div className="total-amount text-end fw-400 text-secondary fs-13 col-md-8 fs-13 d-flex align-items-center justify-content-end gap-1">
                                    {formatToINR(
                                      Number(`${gst?.amount}`).toFixed(2)
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>

                            <hr />
                            <div className="row sub-total ">
                              <div className="total-label fw-500 fs-14 col-md-6 fs-14">
                                Grand Total
                              </div>
                              <div className="total-amount text-end  fw-500  col-md-6 fs-14">
                                {formatToINR(
                                  itemsDetailsData[0]?.["grand-total"] || 0
                                )}
                              </div>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>

            {/* 🔽 Total Section */}
            <Row id="termsAndConditionsSec" className="mt-3">
              <Col md={8}>
                <h3
                  className=" mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Terms & Conditions
                </h3>

                <Form.Group className="mb-3" controlId="formTerms">
                  <p className="ps-1 mb-2 fs-13" style={{ fontWeight: 400 }}>
                    {cloneData?.terms_condition
                      ? TextWithLineBreaks(cloneData?.terms_condition)
                      : "Terms and conditions not available"}
                  </p>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <h3
                  className=" mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Attachment
                </h3>
                <div
                  style={{
                    borderRadius: "10px",
                    padding: "10px 0px",
                    textAlign: "start",
                    width: "100%",
                    maxWidth: "400px",
                    margin: "0px",
                  }}
                >
                  <p
                    style={{ marginBottom: "5px", color: "#666" }}
                    className="d-flex align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faPaperclip}
                      className="me-2 fs-20"
                      style={{ color: "#0099ff", flexShrink: 0 }}
                    />
                    {cloneData?.attachment ? (
                      <a
                        href={`${imageURL}${cloneData?.attachment}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#0099ff",
                          textDecoration: "underline",
                          /* --- START FIX --- */
                          wordBreak: "break-all", // Forces the text to break anywhere necessary
                          overflowWrap: "anywhere", // Ensures it wraps within the container
                          /* --- END FIX --- */
                        }}
                      >
                        {cloneData?.attachment.split("/").pop()}
                      </a>
                    ) : (
                      "No attachment"
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          {/* 🔽 Sales Order Details Section */}

          {/* toggle pdf view */}
          <div
            className="card shadow mt-4"
            id="pdfsViews"
            style={{ display: pdfView ? "block" : "none" }}
          >
            <div className="card-body pt-0">
              {/* --- Header: Logo & Title --- */}
              <div className="row w-100 ms-0">
                <div className="col-md-6 ps-0">
                  {/* Make sure to import or define pugcrm_logo */}
                  <img
                    src={typeof pugcrm_logo !== "undefined" ? pugcrm_logo : ""}
                    alt="logo"
                    style={{
                      height: "130px",
                      width: "160px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div className="col-md-6 d-flex align-items-center justify-content-end ps-0">
                  <h2 className="mb-1">RECURRING INVOICE</h2>
                </div>
              </div>

              {/* --- Address & Details Section (3 Columns) --- */}
              <div className="row mt-4 mb-4 w-100 ms-0">
                {/* Col 1: Billed By (From your original data) */}
                <div className="col-md-4 px-2 d-flex align-items-start justify-content-start flex-column">
                  <p className="mb-2 fw-semibold fs-14">Billed By</p>
                  <p className="mb-1 text-black fw-semibold">
                    {cloneData?.company_name && cloneData?.company_name}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedCompanyBillingAddress.length > 0 ||
                      parsedCompanyBillingAddress !== null ||
                      parsedCompanyBillingAddress !== undefined ? (
                      <>
                        <p className="mb-1 fs-13">
                          {parsedCompanyBillingAddress[0]?.address &&
                            parsedCompanyBillingAddress[0]?.address}
                        </p>
                        <p className="mb-1 fs-13">
                          <p className="mb-1 fs-13">
                            {[
                              parsedCompanyBillingAddress[0]?.city,
                              parsedCompanyBillingAddress[0]?.state,
                              parsedCompanyBillingAddress[0]?.country,
                              parsedCompanyBillingAddress[0]?.zipcode,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </p>
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="fs-13 mb-1">{cloneData?.address}</p>
                        <p className="fs-13 mb-1">
                          {cloneData?.city_name && `${cloneData.city_name}`}
                          {cloneData?.state_name && `, ${cloneData.state_name}`}
                          {cloneData?.nicename && `, ${cloneData.nicename}`}
                          {cloneData?.zipcode && `, ${cloneData.zipcode}`}
                        </p>
                      </>
                    )}
                  </p>
                </div>
                <div className="col-md-4 px-2">
                  <p className="mb-2 fw-semibold fs-14">Billed To</p>
                  <p className="mb-1 text-black fw-semibold">
                    {cloneData?.contact_full_name &&
                      cloneData?.contact_full_name}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedBillingAddress?.address &&
                      parsedBillingAddress.address}{" "}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedBillingAddress?.city &&
                      `${parsedBillingAddress.city}`}
                    {parsedBillingAddress?.state &&
                      `, ${parsedBillingAddress.state}`}
                    {parsedBillingAddress?.country &&
                      `, ${parsedBillingAddress.country}`}
                    {parsedBillingAddress?.zipcode &&
                      `, ${parsedBillingAddress.zipcode}`}
                  </p>
                  {/* <p className="mb-1 fs-13">{salesDetails?.email || "email"}</p> */}
                </div>

                {/* Col 3: Invoice Details */}
                <div className="col-md-4 px-2">
                  <p className="mb-2 fw-semibold fs-14">Invoice Details</p>
                  {/* <p className="mb-1">
                                  Invoice No.:
                                  <span className="fs-14 ms-1 fw-semibold text-black">
                                    #{cloneData.sale_no || "-"}
                                  </span>
                                </p>
                                <p className="mb-1">
                                  Invoice Date:
                                  <span className="fs-14 ms-1 fw-semibold text-black">
                                  </span>
                                </p> */}
                  <p className="mb-1 fs-13">
                    Invoice No.:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      #{cloneData?.invoice_number || "-"}
                    </span>
                  </p>
                  {/* <p className="mb-1 fs-13">
                    Invoice Date:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      {formatDate(cloneData?.invoice_date) || "-"}
                    </span>
                  </p> */}
                  <p className="mb-1 fs-13">
                    Shipment Date:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      {formatDate(cloneData?.shipment_date) || "-"}
                    </span>
                  </p>
                </div>
              </div>

              {/* --- Items Table Section --- */}
              <div className="row">
                <div
                  id="itemsDetailsSection"
                  style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
                >
                  <div className="col-md-12 pe-0 ps-0">
                    <div className="table-responsive quatationsTables2 mb-3">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th className="text-start" width="30%">
                              Items & Description
                            </th>
                            <th className="text-end" style={{ height: "2rem" }}>
                              GST Rate(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th className="text-center" width="10%">
                              Quantity
                            </th>

                            <th className="text-end" width="15%">
                              Rate(<i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th className="text-end" width="15%">
                              Discount(
                              <i className="bi bi-percent"></i>/
                              <i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th
                              className="text-end "
                              style={{ height: "2rem" }}
                            >
                              IGST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th className="text-center pe-2" width="15%">
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemsDetailsData[0]?.itemDetails?.map(
                            (item, index) => {
                              return (
                                <tr key={index}>
                                  <td className="text-start">
                                    <div>
                                      <p
                                        className="mb-0 w-100 d-flex fs-13 align-items-center justify-content-between"
                                        style={{
                                          fontWeight: 500,
                                          width: "auto",
                                        }}
                                      >
                                        {item.name ?? "-"}
                                      </p>
                                      <p
                                        className="mb-0 text-muted"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "13px",
                                          width: "auto",
                                        }}
                                      >
                                        {item.description || "-"}
                                      </p>
                                    </div>
                                  </td>
                                  {/* <td className="text-end">
                                                                <span
                                                                  style={styles.valuesStyle}
                                                                  className="me-3 pt-0"
                                                                >
                                                                  Code
                                                                </span>
                                                              </td> */}
                                  <td className="text-end">
                                    <span
                                      style={styles.valuesStyleForPdf}
                                      className="me-3 pt-0"
                                    >
                                      {item?.gst ?? "-"}
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <span
                                      style={styles.valuesStyleForPdf}
                                      className="me-2 pt-0"
                                    >
                                      {item?.quantity ?? "-"}{" "}
                                    </span>
                                  </td>
                                  {/* <td className="text-end">
                                                                <span
                                                                  className="me-2 pt-0"
                                                                  style={{ fontSize: "13px" }}
                                                                >
                                                                  {item.quantity ?? "-"}{" "}
                                                                  <span className="text-muted font-xxs">
                                                                    pcs
                                                                  </span>
                                                                </span>
                                                              </td> */}

                                  <td className="text-end">
                                    <span
                                      className="me-2 pt-0"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {formatToINR(item.Rate ?? "-")}
                                    </span>
                                  </td>

                                  {/* Example Tax Column matching Sales Order style */}
                                  {/* <td className="text-end">
                                                      <span className="me-3 pt-0">{item?.gst ?? "-"}%</span>
                                                  </td> */}
                                  <td className="text-end">
                                    <span
                                      style={styles.valuesStyleForPdf}
                                      className="me-3 pt-0"
                                    >
                                      {item.discount}
                                      {item.discountType === "Percentage" ? (
                                        <i className="bi bi-percent"></i>
                                      ) : (
                                        <i className="ti ti-currency-rupee"></i>
                                      )}
                                    </span>
                                  </td>
                                  <td className="text-end ">
                                    <span
                                      style={styles.valuesStyleForPdf}
                                      className="me-3 pt-0"
                                    >
                                      {item?.gst ?? "-"}
                                      <i className="bi bi-percent"></i>
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <div className="d-flex gap-2 align-items-center justify-content-center">
                                      <div
                                        className="fs-12 text-end pe-2"
                                        style={{ fontWeight: 500 }}
                                      >
                                        {formatToINR(
                                          item.discountedAmount ?? "-"
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* --- Footer & Totals Section --- */}
              <div className="row mt-3" id="termsAndConditionsSec">
                {/* Left Side: Notes & Terms */}
                <div className="col-md-6 pt-2">
                  <div className="d-flex flex-column">
                    {/* Terms */}
                    <div className="mb-3">
                      <h3
                        className="mb-2 fs-14"
                        style={{ whiteSpace: "nowrap", fontWeight: 400 }}
                      >
                        Terms & Conditions
                      </h3>
                      <p
                        className="mb-2 fs-13 text-muted"
                        style={{ fontWeight: 400 }}
                      >
                        {cloneData.terms_condition ||
                          "No specific terms added."}
                      </p>
                    </div>

                    {/* Notes */}
                    {cloneData.customer_note && (
                      <div>
                        <h3
                          className="mb-2 fs-14"
                          style={{ whiteSpace: "nowrap", fontWeight: 400 }}
                        >
                          Notes
                        </h3>
                        <p className="text-wrap fs-13 fw-normal text-muted">
                          {cloneData.customer_note}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Side: Totals Calculation (Papayawhip Background) */}
                <div className="col-md-6">
                  <div
                    style={{
                      backgroundColor: "papayawhip",
                      borderRadius: "4px",
                    }}
                  >
                    <div className="text-start border-0">
                      <div className="w-100 h-100">
                        <div style={{ padding: "1rem" }}>
                          <div className="row sub-total mb-2 text-semibold ">
                            <div className="total-label fw-semibold col-md-7 d-flex fs-14 align-items-center">
                              Amount
                            </div>
                            <div className="total-amount fs-14 text-end fw-semibold col-md-5 d-flex align-items-center gap-1 justify-content-end">
                              {/* {formatToINR(items[0]?.subTotal)} */}
                              {formatToINR(
                                itemsDetailsData[0]?.["sub-total"] || 0
                              )}
                            </div>
                          </div>
                          <div className="row sub-total mb-1">
                            <div className="total-label col-md-7 fs-13 d-flex  align-items-center  fs-13">
                              Special Discount
                              <span className="ps-1 fs-13">
                                ({itemsDetailsData[0]?.special_discount}
                                <span className="pe-1">
                                  <i>
                                    {itemsDetailsData[0]?.special_DiscountType}
                                  </i>
                                </span>
                                )
                              </span>
                            </div>

                            <div className="total-amount text-end fs-13 text-semibold col-md-5 d-flex align-items-center justify-content-end">
                              -
                              {formatToINR(
                                itemsDetailsData[0]?.special_Discount_Amount ||
                                0
                              )}
                            </div>
                          </div>
                          <div>
                            {itemsDetailsData[0]?.gstBreakdown?.map((gst) => (
                              <div
                                className="row sub-total mb-1"
                                key={gst?.gst}
                              >
                                <div className="total-label col-md-7 d-flex align-items-center fs-13">
                                  IGST
                                  <span className="ps-1 fs-13">
                                    ({gst?.gst}%)
                                  </span>
                                </div>
                                <div className="total-amount text-end col-md-5 fs-13 d-flex align-items-center justify-content-end gap-1">
                                  {formatToINR(
                                    Number(`${gst?.amount}`).toFixed(2)
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="row sub-total mb-1">
                            <div className="total-label col-md-7 d-flex align-items-center fs-13">
                              Shipping Charge
                            </div>
                            <div className="total-amount fs-13 text-end text-semibold col-md-5 d-flex align-items-center gap-1 justify-content-end">
                              {formatToINR(
                                itemsDetailsData[0]?.shipping_Charge || 0
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Grand Total Bar (Blue) */}
                        <div
                          className="row sub-total fw-semibold py-2 mx-0"
                          style={{
                            backgroundColor: "rgb(0, 153, 255)",
                            color: "#ffff",
                            borderBottomLeftRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        >
                          <div className="total-label fw-semibold fs-14 col-md-6 ps-3">
                            Total
                          </div>
                          <div className="total-amount fs-14 text-end fw-semibold col-md-6 pe-3">
                            {formatToINR(
                              itemsDetailsData[0]?.["grand-total"] || 0
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* --- Signature --- */}
              <div className="mt-5 fs-13 ps-0">
                <p>Authorised Signature _________________</p>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {showEmailModal && (
        <EmailModal
          show={showEmailModal}
          onClose={handleCloseEmailModal}
          id={cloneData?.id}
          pipelineId={""}
          customerId={customer_id}
          loginId={loginUserId}
          headers={headers}
          extras={extras}
          data={cloneData} // Pass lead data for pre-populating emails
          module_name={"invoice"}
        />
      )}

      {/* WhatsApp Modal */}
      {showWhatsappModal && (
        <WhatsappModal
          whatsappModalOpen={showWhatsappModal}
          setWhatsAppModalOpen={setShowWhatsappModal}
          id={cloneData?.id}
          module_name={"invoice"}
        />
      )}

      {/*payment list modal */}
      <style jsx>
        {`
          .sales-order-accordion .accordion-button:not(.collapsed) {
            background-color: #ffffff;
            box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0
              var(--bs-accordion-border-color);
            color: var(--bs-accordion-active-color);
          }

          .list-unlisted {
            list-style: none !important;
            display: flex !important;
            width: fit-content !important;
            text-align: center !important;
            border-bottom: none !important;
            background-color: #ffffff !important;
            margin-bottom: 0px !important;
            width: 100% !important;
            padding-left: 0px !important;
            border-top: none !important;
          }

          .list-unlisted .listed {
            padding: 6px 12px !important;
            border-left: 1px solid #ebeaf2 !important;
            font-size: 13px !important;
            cursor: pointer !important;
            background: #e9e9e9 !important;
            color: #373636 !important !important;
            border-radius: 3px !important;
          }

          .quatationsTables2 table thead tr th {
            font-size: 0.8rem !important;
            background: #dbdbdb57 !important;
            padding: 0px 16px !important;
            height: 2.5rem;
            font-family: "Inter", sans-serif !important;
            line-height: 1.5;
            letter-spacing: 0.0573rem;
            border-bottom: 1px solid #d8e6f7 !important;
            border-radius: 0px !important;
          }

          .quatationsTables2 table thead tr th:first-child {
            border-top-left-radius: 0px !important;
            /* width: 60px; */
            text-align: center;
            background: #dbdbdb57 !important;
            font-weight: 300;
            color: black !important;
          }
          .quatationsTables2 .table thead {
            position: relative;
            height: auto !important;
            top: 0px;
          }
          .quatationsTables2 table tbody tr td:last-child,
          .quatationsTables2 table tbody tr th:last-child {
            border-right: none !important;
          }
          .quatationsTables2 table tbody tr td {
            font-size: 13px !important;
          }
          .quatationsTables2 table tbody tr:last-child th:first-child {
            border-right: none !important;
          }
          .quatationsTables2 table thead tr th:last-child {
            border-top-right-radius: 0px !important;
            /* width: 60px; */
            text-align: center;
            /* background: #dbdbdb57 !important; */
            font-weight: 300;
            color: black !important;
          }

          .quatationsTables2.table-responsive {
            border: 1px solid lightblue !important;
            border-radius: 5px !important;
          }

          .quatationsTables2.table-responsive table {
            border-radius: 5px !important;
          }

          .quatationsTables2 tr th {
            padding: 10px 7px 10px 10px !important;
            border-right: 1px solid lightblue !important;
          }

          .quatationsTables2 tr td {
            padding: 7px 7px 7px 15px !important;
            border-bottom: 1px solid #d1e9f1 !important;
            border-right: 1px solid lightblue !important;
          }
        `}
      </style>
    </>
  );
};

const styles = {
  valuesStyle: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.77rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyle1: {
    marginBottom: 0,
    paddingTop: 25,
    paddingLeft: 13,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 500,
    color: "black",
    cursor: "pointer",
  },
  lableText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: "normal",
    fontSize: "13px",
    fontWeight: 300,
  },
  cardDiv: {
    border: "1px solid lightblue",
    borderRadius: "3px",
    padding: "18px 18px",
    lineHeight: "0.6rem",
  },
  cardLabel: {
    marginBottom: 1,
    fontSize: "13px",
    fontWeight: 300,
    minWidth: "125px",
  },
  cardLebelData: {
    textTransform: "capitalize",
    color: "black",
    fontWeight: 400,
    fontSize: "13px",
  },
};

export default RecurringInvoiceDetails;
